import { ApiPropertyOptional } from '@nestjs/swagger'
import { IsOptional, IsString, Length } from 'class-validator'

export class UpdateActivityStateRequestDto {
  @ApiPropertyOptional({ description: 'Code unique de l\'état', minLength: 2, maxLength: 64 })
  @IsOptional()
  @IsString()
  @Length(2, 64)
  code?: string

  @ApiPropertyOptional({ description: 'Libellé de l\'état' })
  @IsOptional()
  @IsString()
  label?: string
}

